import type {
  DataUpdateJobStatus,
  ManagedCustomDashboardTabsConfig,
} from '@/lib/api/custom-dashboard';

/** タブ設定の再取得を15秒間隔に切り替える際のポーリング間隔（ミリ秒）。 */
export const DATA_UPDATE_POLL_INTERVAL_MS = 15_000;

/** ジョブが終端状態（succeeded/failed）かどうか。ポーリング終了後の invalidate 判定に使う。 */
export function isTerminalDataUpdateStatus(status: DataUpdateJobStatus): boolean {
  return status === 'succeeded' || status === 'failed';
}

/** ジョブが実行中（running）かどうか。終端状態の否定として定義し単一の真実源を保つ。 */
export function isActiveDataUpdateStatus(status: DataUpdateJobStatus): boolean {
  return !isTerminalDataUpdateStatus(status);
}

/**
 * いずれかのタブでデータ更新ジョブが実行中かどうか。
 * `useQuery` の `refetchInterval` に渡す純関数として切り出し、フック本体に依存せず単体テストする。
 */
export function hasActiveDataUpdateJob(
  data: ManagedCustomDashboardTabsConfig | undefined,
): boolean {
  if (!data) return false;
  return data.tabs.some(
    (tab) => tab.latestDataUpdate !== null && isActiveDataUpdateStatus(tab.latestDataUpdate.status),
  );
}
